import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { Container, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState, useRef, useContext, RefObject, Fragment } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import filterIcon from '../../assets/filterIcon.svg'
import { SUCCESS } from '../../constants/Constants'
import { getAllApps, getFeaturedApps, getFilters, getStaffPickedApps } from '../../services/MarketplaceService'
import { CloseIcon } from '../../SvgUtility'
import AppCards from '../common/AppCards'
import FiltersPane from '../common/FiltersPane/FiltersPane'
import Noresult from '../../assets/file_not_found.svg'
import RelatedApps from '../details/RelatedApps'
import { AppContext } from '../../App'
import Spinner from '../../utility/Spinner'
import FeaturedApp from './FeaturedApps'
import Collections from './Collections'
import { Header } from '../../css/Style'

interface HiddenProps {
  hide: boolean;
}

interface KeyboardEvent {
  key: string;
}
const SpinCoords = styled.div`
  margin: 0 auto;
`

const containerStyles = {
  '@media (min-width: 900px) and (max-width: 1200px)': {
    width: '33%'
  },
  '@media (min-width: 421px) and (max-width: 900px)': {
    marginLeft: '0%',
    background: '#25233B',
    position: 'relative'
  },
  '@media (min-width: 0px) and (max-width: 420px)': {
    marginLeft: '1%',
    position: 'relative'

  },
  '@media (min-width: 1201px)': {
    width: '600px'
  }
}

const container = {
  background: 'white',
  borderRadius: '20px',
  '@media (min-width: 901px) and (max-width: 1349)': {
    marginLeft: '5%',
    maxWidth: '-webkit-fill-available',
    marginRight: '5%',
    padding: '10px'
  },

  '@media (min-width: 1350px)': {
    width: '1296px',
    maxWidth: '1296px',
    height: 'auto',
    margin: 'auto',
    justifyContent: 'center',
    padding: '48px'
  }
}

const seachstyle = {
  backgroundColor: 'white',
  minWidth: '590px',
  display: 'flex',
  '@media (min-width: 0px) and (max-width: 450px)': {
    minWidth: '287px',
    borderRadius: '7px'
  },
  '@media (min-width: 451px) and (max-width: 900px)': {
    borderRadius: '7px',
    zIndex: 1,
    minWidth: '463px'
  }

}

const SideNav = styled.div`
  height: 100%;
  width: 260px;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  background-color: #ffff;
  transition: 0.5s;
  padding-top: 30px;
  padding-left: 4%;
  border-radius: 0px 14px;

`

const HomePageDiv = styled.div`
  @media (min-width: 901px){
    background: #25233B;
  }
`

const WelcomeDiv = styled.div<HiddenProps>`
  @media (min-width: 1201px)  {
      width: 1296px;
      height: ${(props) => props.hide ? '30px' : ''};
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: ${(props) => props.hide ? '0px' : '0px auto 25px'} ;
      flex-direction: row;
    };
    @media (min-width: 901px) and (max-width: 1200px) {
      width: 100%;  
      height: ${(props) => props.hide ? '30px' : '400px'};
      align-items: center;
      display: flex;
      justify-content: flex-end;
    };
    @media (min-width: 451px) and (max-width: 900px) {
      height: ${(props) => props.hide ? '95px' : '316px'};
      background-color: #25233B;
  }
    @media (min-width: 0px) and (max-width: 450px) {
      height: ${(props) => props.hide ? '95px' : '535px'};
      background-color: #25233B;
  }
`
const Banner = styled.div<HiddenProps>`
  @media (min-width: 1201px)  {
      background-repeat: no-repeat;
      background-image: url(homePage/BannerTrans.svg);
      display: ${(props) => props.hide ? 'none' : 'flex'};
      width: inherit;
      height: 317px;
      background-size: 850px;
      background-position: 84%;
    };
    @media (min-width: 901px) and (max-width: 1200px)  {
      margin-top: 152px;
      width: 59%;
      background-repeat: no-repeat;
      background-image: url(homePage/BannerTrans.svg);
      height: 368px;
      background-size: contain;
      display: ${(props) => props.hide ? 'none' : 'flex'};
    };
`

const BannerDiv = styled.div<HiddenProps>`
  top: 26px;
  width: 706px;
  height: 200px;
  background-size: cover;
  position: relative;
  @media (min-width: 0px) and (max-width: 450px) {
    left: -341px;
    background-image: url('homePage/Banner.svg');
    display: ${(props) => props.hide ? 'none' : 'flex'}
  }
  @media (min-width: 451px) and (max-width: 900px) {
    position: absolute;
    background-image: url('homePage/BannerTrans.svg'); 
    top: 46px;
    margin-left: 42px;
    width: 509px;
    height: 197px;
    display: ${(props) => props.hide ? 'none' : 'flex'}
  }
  @media (min-width: 751px) and (max-width: 900px) {
    left: 28%;
  }
  @media (min-width: 451px) and (max-width: 650px) {
    left: -4%;
  }
  @media (min-width: 651px) and (max-width: 750px) {
    left: 4%;
  }

  @media (min-width: 901px)  {
    display : none
  };

`

const NoresultImg = styled.img.attrs(() => ({
  src: Noresult
}))`
    display:block;
    align-items: center;
    justify-content: center;
    width: 522px;
    margin: 73.51px auto 21.9px;
    height: 291.39px;
    @media (min-width: 0px) and (max-width: 420px) {
        width: 96%;
    }
    @media (min-width: 421px) and (max-width: 900px) {
      width: 84%;
      margin: auto;
    }
`

const TitleDiv = styled.div<HiddenProps>`
width: 603px;
text-align: left;
padding-top: ${(props) => props.hide ? '30px' : '0px'};
color: #FFFFFF;
display: ${(props) => props.hide ? 'none' : 'flex'};
flex-direction: column;
@media (min-width: 0px) and (max-width: 450px) {
  width: 100%;
}
@media (min-width: 451px) and (max-width: 700px) {
  width: 95%;
  padding-top: ${(props) => props.hide ? '30px' : '54px'};

}
@media (min-width: 701px) and (max-width: 900px) {
  width: 468px;
  padding-top: ${(props) => props.hide ? '30px' : '54px'};

}
@media (min-width: 421px) and (max-width: 900px) {
  padding-top: ${(props) => props.hide ? '30px' : '54px'};

}
`

const Title = styled.span<HiddenProps>`
font-family: "AeonikPro-Medium";
font-style: normal;
font-weight: 500;
font-size: 48px;
line-height: 60px;
letter-spacing: -0.04em;
z-index:1;
display: ${(props) => props.hide ? 'none' : 'flex'};
@media (min-width: 0px) and (max-width: 420px) {
  font-size: 28px;
  line-height: 34px;
  display: flow-root;
  margin-top: 48px;
  width: 200px;
}
@media (min-width: 421px) and (max-width: 900px) {
  font-size: 36px;
  line-height: 54px;
  display: flow-root;
}

`
const TextStyle = styled.span`
  margin-right: 8px;
  @media (min-width: 0px) and (max-width: 600px) {
    margin-right: 6px;
  }

`
const TextYellow = styled.span`
  color: #f4a250
`

const SubTitle = styled.div<HiddenProps>`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 24px;
z-index:100;
width: 590px;
height: 56px;
left: 0px;
margin-top: 16px;
display: ${(props) => props.hide ? 'none' : 'flex'};
@media (min-width: 0px) and (max-width: 767px) {
  width: 344px;
  margin-bottom : 15px;
}

`

const SearchDiv = styled.div<HiddenProps>`
display: flex;
flex-direction: row;
align-items: center;
margin-top: 16px;

width: 676px;
height: 44px;
left: 0px;
top: 172px;
@media (min-width: 0px) and (max-width: 900px) {
  margin-top:  ${(props) => props.hide ? '0px' : '16px'};

};
@media (min-width: 901px) {
  display:  ${(props) => props.hide ? 'none' : 'flex'};
}
`

const AppContainer = styled.div`

display: ${props => props.hidden ? 'none' : 'inline-block'};
@media (min-width: 0px) and (max-width: 450px) {
  width: 100%
}
@media (min-width: 451px) and (max-width: 900px) {
  width  100%;
  margin-left: 10px;
}
@media (min-width: 1350px) {
  margin-left: 20px;
};

@media (min-width: 901px) and (max-width: 1349px) {
  width: 74%;
  margin-left: 20px;
}
`

const Body = styled.div<HiddenProps>`
display: flex;
margin-top: 52px;
height: ${props => props.hide ? '' : '1075px'};
@media (min-width: 901px) {
  margin-top: 0px;
}
@media (min-width: 0px) and (max-width: 900px){
  margin-top: 16px;
  padding-left: 0px;
};
`

const ContactHeader = styled.div`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 32px;
color: #35324A;
padding: 14px;
@media (min-width: 1201px){
  display: block;
    margin: 0px auto;
    width: fit-content;
}
@media (min-width: 421px) and (max-width: 1200px){
  display: block;
    margin: auto;
    width: fit-content;
}
`

const ContactBody = styled.div`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
color: #8A8A9C;
padding-bottom: 19px;
padding-left: 4px;
padding-right: 8px;
@media (min-width: 1201px){
  text-align: center;
  display: block;
  margin: 0px auto 0px auto;
  width: 41%;
}
@media (min-width: 421px) and (max-width: 1200px){
  text-align: center;
  display: block;
  margin: auto;
  width: 100%;
}
`

const Contact = styled.div`
  cursor: pointer;
  font-family: 'AeonikPro-Medium';
  font-style: normal;
  font-weight: 400;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  color: white;
  font-size: 16px;
  border-radius: 4px;
  background: #FF6B18;

  @media (min-width: 901px) {
    width: 435px;
    height: 52px;
    margin: 0px auto;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  @media (min-width: 0px) and (max-width: 420px) {
    width: 100%;
    height: 48px;
  }
  @media (min-width: 421px) and (max-width: 900px) {
    width: 50%;
    height: 48px;
    margin: auto;
  }
`
const FilterIcon = styled.img`

`

const FilterStyles = styled.div`
  @media (min-width: 0px) and (max-width: 900px){
    width : 44px;
    height : 40px;
    background: #F1F5F9;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-top: 7px;
    margin-right: 7px;
    z-index: 1;
  };
  @media (min-width: 901px) {
    display : none
  };
`

const StaffPicks = styled.div`
margin-top: 68px;
@media (min-width: 0px) and (max-width: 900px){
  margin-top: 25px;
}
`

const SearchResult = styled.div`
  @media (min-width: 900px) {
    display: ${props => props.hidden ? 'none' : 'flex'};
    flex-direction: column;
  }
  margin-left: 20px;
  width: 95%;
  @media (min-width: 900px) {
    width: 74%;
  }
`

const FilteredResultContainer = styled.div`
display: ${props => props.hidden ? 'none' : 'flex'};
@media (min-width: 0px) and (max-width: 900px){
  display : block;
}
`

const FilteredResultTextContainer = styled.div`
margin-top: 34px;
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 24px;
@media (min-width: 0px) and (max-width: 767px){
  margin-top: 6px;
}
`

const FilterBubbleContainer = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
`

const Filter = styled.div`
background: #F1F1EE;
border-radius: 20px;
width: 216px;
height: 36px;
margin-top: 28px;
margin-left: 10px;
display: ${props => props.hidden ? 'none' : 'flex'};
@media (min-width: 0px) and (max-width: 767px){
  margin-top: 15px;
  margin-left: 0px;
};
`

const FilterText = styled.div`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 20px;
color: #35324A;
margin-top: 8px;
width: 179px;
margin: auto;
margin-right: 0px;
text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
`

const CloseIconContainer = styled.div`
padding-top: 9px;
padding-right: 12px;
cursor: pointer;
`

const ClearAllText = styled.div`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 24px;
margin-top: 34px;
margin-left: 10px;
color: #8A8A9C;
cursor: pointer;
@media (min-width: 0px) and (max-width: 767px){
  font-size: 14px;
  margin-top: 20px;
};
`

const MainContainer = styled.div`
  @media (min-width: 0px) and (max-width: 1349px){
    overflow-x: hidden;
  }
`
const NoResContainer = styled.span`

`
const SpinnerDiv = styled.div`
  width: 100%;
  height: 100vh;
  display: inline-flex;
`

export interface AppDataList {
  appId: string;
  name: string;
  description: string;
  useCaseList: string[];
  categoryList: string[];
  applicationList: string[];
  featureVideo: string[];
  featureGif: string[];
  icon: string;
  featureImage: string;
}

const appData: AppDataList[] = []

interface QueryParams {
  useCase: string | null;
  category: string | null;
  application: string | null;
  collection: string | null;
  searchTerm : string | null
}

const HomePage = () => {
  const { searchTerm, setSearchTerm } = useContext(AppContext)
  const { showSearch, setShowSearch } = useContext(AppContext)
  const [searchParams] = useSearchParams()
  const [useCaseFilter, setUseCaseFilter] = useState(searchParams.get('useCase') ? searchParams.get('useCase') : '')
  const [categoriesFilter, setCategoriesFilter] = useState(searchParams.get('category') ? searchParams.get('category') : '')
  const [applicationsFilter, setApplicationsFilter] = useState(searchParams.get('application') ? searchParams.get('application') : '')
  const [collectionsFilter, setCollectionsFilter] = useState(searchParams.get('collection') ? searchParams.get('collection') : '')
  const [searchFilter, setSearchFilter] = useState(searchParams.get('searchTerm') ? searchParams.get('searchTerm') : '')
  const [useCaseList, setUseCaseList] = useState([])
  const [categoriesList, setCategoriesList] = useState([])
  const [applicationsList, setApplicationsList] = useState([])
  const [collectionsList, setCollectionsList] = useState([])
  const [appList, setAppList] = useState(appData)
  const [featuredAppList, setFeaturedAppList] = useState(appData)
  const [hasUseCasesLoaded, setHasUseCasesLoaded] = useState(false)
  const [hasApplicationsLoaded, setHasApplicationsLoaded] = useState(false)
  const [hasCategoriesLoaded, setHasCategoriesLoaded] = useState(false)
  const [hasCollectionsLoaded, setHasCollectionsLoaded] = useState(false)
  const [hasAppsLoaded, setHasAppsLoaded] = useState(false)
  const [staffPickedAppsList, setStaffPickedAppsList] = useState(appData)
  const searchTermQueryParam = searchParams.get('searchTerm')
  const useCaseQueryParam = searchParams.get('useCase')
  const applicationQueryParam = searchParams.get('application')
  const categoryQueryParam = searchParams.get('category')
  const collectionQueryParam = searchParams.get('collection')
  const [toggleMenu, setToggleMenu] = useState(false)
  const [searchToggle, setSearchToggle] = useState(false)
  const [featuredApps, setFeaturedApps] = useState(appData)
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)
  const navigate = useNavigate()
  const { searchInput, setSearchInput } = useContext(AppContext)
  const [popularApps, setPopularApps] = useState(appData)
  const [showLessEnabled, setShowLessEnabled] = useState(false)

  useEffect(() => {
    if (useCaseQueryParam || applicationQueryParam || categoryQueryParam || searchTermQueryParam || collectionQueryParam) {
      setHasAppsLoaded(false)
      const queryParams: QueryParams = {
        useCase: useCaseFilter,
        category: categoriesFilter,
        application: applicationsFilter,
        collection: collectionsFilter,
        searchTerm: searchFilter
      }
      const getAllAppsQueryUrl = replaceUrl(queryParams)
      getAllApps(getAppList, getAllAppsQueryUrl)
    } else {
      setHasAppsLoaded(true)
    }
    getFeaturedApps(getFeaturedAppList)
    getStaffPickedApps(getStaffPickedAppsList)
    getFilters('usecases', getUseCases)
    getFilters('applications', getApplications)
    getFilters('categories', getCategories)
    getFilters('collections', getCollections)
    document.title = 'Marketplace'
  }, [])

  useEffect(() => {
    if (featuredAppList && featuredAppList.length) {
      let apps = featuredAppList.slice(0, 2)
      if (apps.length < 2) {
        setFeaturedApps(apps)
      } else {
        apps = !apps[0].featureVideo && apps[1].featureVideo
          ? [apps[1], apps[0]]
          : !apps[0].featureVideo && !apps[0].featureGif && apps[1].featureGif
              ? [apps[1], apps[0]]
              : apps
        setFeaturedApps(apps)
      }
    }
  }, [featuredAppList])

  const enableShowLess = (val: boolean): void => {
    setShowLessEnabled(val)
  }

  const filterOnClickAction = (useCase?: string, category?: string, application?: string, searchTerm?: string) => {
    window.scrollTo(0, 0)
    setHasAppsLoaded(false)
    setShowSearch(true)
    const queryParams: QueryParams = {
      useCase: useCaseFilter,
      category: categoriesFilter,
      application: applicationsFilter,
      collection: collectionsFilter,
      searchTerm: searchFilter
    }
    if (useCase && useCase !== useCaseFilter) {
      setUseCaseFilter(useCase)
      queryParams.useCase = useCase
    } else if (useCase) {
      setUseCaseFilter('')
      queryParams.useCase = ''
    }
    if (category) {
      setCategoriesFilter(category)
      queryParams.category = category
    }
    if (application) {
      setApplicationsFilter(application)
      queryParams.application = application
    }
    if (searchTerm) {
      setSearchFilter(searchTerm)
      queryParams.searchTerm = searchTerm
    }
    const queryUrl: string = replaceUrl(queryParams)
    getAppsOnFilterChange(queryUrl)
    setToggleMenu(false)
  }

  const appendQueryParam = (paramArr: Array<string>, name: string, value: string|null) : void => {
    if (value) {
      paramArr.push(name + '=' + encodeURIComponent(value))
    }
  }

  const replaceUrl = (queryParams: QueryParams): string => {
    const paramArr: Array<string> = []
    appendQueryParam(paramArr, 'useCase', queryParams.useCase)
    appendQueryParam(paramArr, 'category', queryParams.category)
    appendQueryParam(paramArr, 'supportedApplication', queryParams.application)
    appendQueryParam(paramArr, 'collection', queryParams.collection)
    appendQueryParam(paramArr, 'searchTerm', queryParams.searchTerm)
    return paramArr.length > 0 ? '?' + paramArr.join('&') : ''
  }

  useEffect(() => {
    if (searchTerm && searchTerm.trim().length) {
      setShowSearch(true)
      const queryParams: QueryParams = {
        useCase: useCaseFilter,
        category: categoriesFilter,
        application: applicationsFilter,
        collection: collectionsFilter,
        searchTerm: searchFilter
      }

      setSearchFilter(searchTerm)
      queryParams.searchTerm = searchTerm

      const queryUrl: string = replaceUrl(queryParams)
      getAppsOnFilterChange(queryUrl)
    }
  }, [searchTerm])

  useEffect(() => {
    if (!showSearch) {
      setSearchInput('')
      setSearchToggle(false)
      setApplicationsFilter('')
      setCategoriesFilter('')
      setUseCaseFilter('')
      setCollectionsFilter('')
      setSearchFilter('')
      getAllApps(getAppList, '')
    }
  }, [showSearch])

  const search = () => {
    setSearchTerm(searchInput)
  }

  const removeFilter = (filterName: string) => {
    setHasAppsLoaded(false)
    const queryParams: QueryParams = {
      useCase: useCaseFilter,
      category: categoriesFilter,
      application: applicationsFilter,
      collection: collectionsFilter,
      searchTerm: searchFilter
    }
    if (filterName === 'useCase') {
      setUseCaseFilter('')
      queryParams.useCase = ''
    } else if (filterName === 'category') {
      setCategoriesFilter('')
      queryParams.category = ''
    } else if (filterName === 'application') {
      setApplicationsFilter('')
      queryParams.application = ''
    } else if (filterName === 'collection') {
      setCollectionsFilter('')
      queryParams.collection = ''
    } else if (filterName === 'searchTerm') {
      setSearchTerm('')
      setSearchInput('')
      setSearchToggle(false)
      setSearchFilter('')
      queryParams.searchTerm = ''
    }
    if (queryParams.useCase === '' && queryParams.category === '' && queryParams.application === '' && queryParams.searchTerm === '') {
      setSearchToggle(true)
    }
    const queryUrl: string = replaceUrl(queryParams)
    getAppsOnFilterChange(queryUrl)
  }

  const resetFilters = () => {
    setHasAppsLoaded(false)
    getAllApps(getAppList, '')
    setApplicationsFilter('')
    setCategoriesFilter('')
    setUseCaseFilter('')
    setCollectionsFilter('')
    setSearchFilter('')
    setSearchToggle(true)
    setSearchInput('')
  }

  const areFiltersApplied = (): boolean => {
    return (useCaseFilter === '' && categoriesFilter === '' && applicationsFilter === '' && collectionsFilter === '' && searchFilter === '' && !searchToggle)
  }

  const applyCollectionsFilter = (collectionName: string) => {
    setShowSearch(true)
    setSearchToggle(true)
    const queryParams: QueryParams = {
      useCase: useCaseFilter,
      category: categoriesFilter,
      application: applicationsFilter,
      collection: collectionName,
      searchTerm: searchFilter
    }
    setCollectionsFilter(collectionName)
    const queryUrl: string = replaceUrl(queryParams)
    getAppsOnFilterChange(queryUrl)
  }

  const getAppList = (response: AppDataList[], status: string) => {
    if (status === SUCCESS) {
      setAppList(response)
      setHasAppsLoaded(true)
    }
  }

  useEffect(() => {
    if (appList && appList.length > 3) {
      setPopularApps(appList.slice(0, 3))
    }
  }, [appList])

  const getFeaturedAppList = (response: AppDataList[], status: string) => {
    if (status === SUCCESS) {
      setFeaturedAppList(response)
    }
  }

  const getStaffPickedAppsList = (response: AppDataList[], status: string) => {
    if (status === SUCCESS) {
      setStaffPickedAppsList(response)
    }
  }

  const getUseCases = (response: [], status: string) => {
    if (status === SUCCESS) {
      setUseCaseList(response)
    } else {
      setUseCaseList([])
    }
    setHasUseCasesLoaded(true)
  }

  const getCategories = (response: [], status: string) => {
    if (status === SUCCESS) {
      setCategoriesList(response)
    } else {
      setCategoriesList([])
    }
    setHasCategoriesLoaded(true)
  }

  const getApplications = (response: [], status: string) => {
    if (status === SUCCESS) {
      const resp = response.sort(function (a: string, b: string) {
        return a.toLowerCase().localeCompare(b.toLowerCase())
      }).filter(x => x !== 'custom')
      setApplicationsList(resp)
    } else {
      setApplicationsList([])
    }
    setHasApplicationsLoaded(true)
  }

  const getCollections = (response: [], status: string) => {
    if (status === SUCCESS) {
      setCollectionsList(response)
    } else {
      setCollectionsList([])
    }
    setHasCollectionsLoaded(true)
  }

  const getAppsOnFilterChange = (queryUrl: string): void => {
    setHasAppsLoaded(false)
    getAllApps(getAppList, queryUrl)
  }

  const hasDataLoaded = (): boolean => {
    return hasUseCasesLoaded && hasCategoriesLoaded && hasApplicationsLoaded && hasCollectionsLoaded && hasAppsLoaded
  }

  const hasFilterLoaded = (): boolean => {
    return hasUseCasesLoaded && hasCategoriesLoaded && hasApplicationsLoaded && hasCollectionsLoaded
  }

  // hook to get click outside of side nav
  function useOutsideAlerter (ref: RefObject<HTMLElement>) {
    useEffect(() => {
      function handleClickOutside (event: Event) {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          setToggleMenu(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  function routeToContact () {
    navigate('/getInTouch')
  }

  const handleEnter = (event : KeyboardEvent) => {
    if (event.key === 'Enter') {
      search()
    }
  }

  const filtersEnabled = useCaseFilter === '' && categoriesFilter === '' && applicationsFilter === '' && collectionsFilter === '' && searchFilter === ''
  return (
    <MainContainer>
        <HomePageDiv>
          <WelcomeDiv hide={!areFiltersApplied()}>
            <Container sx={containerStyles}>
              <TitleDiv hide={!areFiltersApplied()}>
                <Title hide={!areFiltersApplied()}>
                  <TextStyle>Digital</TextStyle>
                  <TextStyle>adoption</TextStyle>
                  <TextStyle>made</TextStyle>
                  <TextYellow>simple</TextYellow>
                </Title>
                <SubTitle hide={!areFiltersApplied()}>
                Unlock the best practices for your software applications and accelerate your organization’s digital adoption.
                </SubTitle>
              </TitleDiv>
              <SearchDiv hide={!areFiltersApplied() && showSearch}>
                <FilterStyles onClick={() => setToggleMenu(true) }>
                  <FilterIcon src={filterIcon} />
                </FilterStyles>
                {toggleMenu && <SideNav ref={wrapperRef} >
                  <FiltersPane
                  enableShowLess = {enableShowLess}
                  showLessEnabled = {showLessEnabled}
                filterOnClickAction={filterOnClickAction}
                useCases={useCaseList}
                categories={categoriesList}
                applications={applicationsList}
                useCaseFilter={useCaseFilter}
                applicationsFilter={applicationsFilter}
                categoriesFilter={categoriesFilter}
                toggleMenu ={toggleMenu} />
                </SideNav>}
                <TextField sx ={seachstyle}
                  margin="normal"
                  variant="outlined"
                  placeholder={'Search'}
                  size="small"
                  InputProps={{
                    type: 'search',
                    endAdornment: (
                      <InputAdornment position="start" style={{ color: '#64748B', cursor: 'pointer', paddingLeft: '16px', paddingTop: '4px' }}>
                        <SearchOutlinedIcon onClick={() => { search() }} />
                      </InputAdornment>
                    )
                  }}
                  inputProps={{
                    maxLength: 50
                  }}
                  style={{
                    backgroundColor: 'white',
                    display: 'flex',
                    borderRadius: '5px'
                  }}
                  value ={searchInput}
                  onKeyDown={handleEnter}
                  onChange={(event) => setSearchInput(event.target.value)}
                />
              </SearchDiv>
              <BannerDiv hide={!areFiltersApplied()}> </BannerDiv>
            </Container>
            <Banner hide={!areFiltersApplied()} />
          </WelcomeDiv>
          <Container sx={container}>

          <Body hide = {hasDataLoaded()}>

          {hasFilterLoaded() && <Fragment>
              <FiltersPane
                filterOnClickAction={filterOnClickAction}
                enableShowLess = {enableShowLess}
                showLessEnabled = {showLessEnabled}
                useCases={useCaseList}
                categories={categoriesList}
                applications={applicationsList}
                useCaseFilter={useCaseFilter}
                applicationsFilter={applicationsFilter}
                categoriesFilter={categoriesFilter} />
                <AppContainer hidden={!areFiltersApplied()}>
                {featuredApps && featuredApps.length > 0 && <FeaturedApp featuredApps = {featuredApps || []}/>}
                {process.env.REACT_APP_SHOW_COLLECTION === 'true' && <Collections collectionsList ={collectionsList} applyCollectionsFilter = {applyCollectionsFilter}/>}
                {staffPickedAppsList && staffPickedAppsList.length > 0 && <StaffPicks>
                  <Header>Our Picks</Header>
                  <AppCards apps={staffPickedAppsList}></AppCards>
                </StaffPicks>}
                {appList && appList.length > 0 && <StaffPicks>
                  <Header>All</Header>
                  <AppCards apps={appList}></AppCards>
                </StaffPicks>}

              </AppContainer>
              {!hasDataLoaded() &&
              <SpinnerDiv>
                <SpinCoords>
                  <Spinner/>
                </SpinCoords>
              </SpinnerDiv>}
             {hasAppsLoaded && <SearchResult hidden={areFiltersApplied()}>
                <Header style={{ marginLeft: '0px' }}>{filtersEnabled ? 'All' : 'Search Results'}</Header>
                <FilteredResultContainer hidden={filtersEnabled}>
                  <FilteredResultTextContainer>
                    {appList.length} results filtered by:
                  </FilteredResultTextContainer>
                  <FilterBubbleContainer>
                    <Filter hidden={useCaseFilter === ''}>
                      <FilterText>{useCaseFilter}</FilterText>
                      <CloseIconContainer onClick={() => removeFilter('useCase')}>
                        <CloseIcon width="12px" height="12px" fill="#35324A" />
                      </CloseIconContainer>
                    </Filter>
                    <Filter hidden={categoriesFilter === ''}>
                      <FilterText>{categoriesFilter}</FilterText>
                      <CloseIconContainer onClick={() => removeFilter('category')}>
                        <CloseIcon width="12px" height="12px" fill="#35324A" />
                      </CloseIconContainer>
                    </Filter>
                    <Filter hidden={applicationsFilter === ''}>
                      <FilterText>{applicationsFilter}</FilterText>
                      <CloseIconContainer onClick={() => removeFilter('application')}>
                        <CloseIcon width="12px" height="12px" fill="#35324A" />
                      </CloseIconContainer>
                    </Filter>
                    <Filter hidden={collectionsFilter === ''}>
                      <FilterText>{collectionsFilter}</FilterText>
                      <CloseIconContainer onClick={() => removeFilter('collection')}>
                        <CloseIcon width="12px" height="12px" fill="#35324A" />
                      </CloseIconContainer>
                    </Filter>
                    <Filter hidden={searchFilter === ''}>
                      <FilterText>{searchFilter}</FilterText>
                      <CloseIconContainer onClick={() => removeFilter('searchTerm')}>
                        <CloseIcon width="12px" height="12px" fill="#35324A" />
                      </CloseIconContainer>
                    </Filter>
                    <ClearAllText onClick={resetFilters}>Clear filters</ClearAllText>
                  </FilterBubbleContainer>
                </FilteredResultContainer>
                {appList.length === 0 && <NoResContainer>
                  <NoresultImg />
                  <ContactHeader>We couldn’t find anything matching your search</ContactHeader>
                  <ContactBody>Try changing your filters or search terms. If you still can’t find what you’re looking for, let us know so we can help you.</ContactBody>
                  <Contact onClick={routeToContact}>Contact Us</Contact>
                   {!areFiltersApplied() && <RelatedApps isSearch={true} apps= {popularApps}/>}
                </NoResContainer>}

                <AppCards apps={appList}></AppCards>
              </SearchResult>}
              </Fragment>}

            </Body>
          </Container>
        </HomePageDiv>
    </MainContainer>
  )
}

export default HomePage
